import UploadDocumentsAction from './UploadDocumentsAction'
export default UploadDocumentsAction
